import { getPlayerById } from '../state/selectors';
import {
  drawCards, grantGold, grantPhysicalAttack, grantMagicAttack, grantLight, queueHandChoice,
} from '../cards/effectHelpers';
import { XP_TOKEN_COLORS } from '../state/xpTokens';

// Numenera's colored-XP rule (state/xpTokens.js): "A player can discard one
// XP on their turn to get an effect based on which color they discarded" -
// free, once per turn, independent of any card and not gated to a specific
// phase (Matt: "in addition to your normal Village/Dungeon action").
const XP_TOKEN_SPEND_EFFECTS = {
  blue: (state, playerId) => drawCards(state, playerId, 1),
  gray: (state, playerId) => {
    const player = getPlayerById(state, playerId);
    return queueHandChoice(state, { playerId, verb: 'destroy', candidateInstanceIds: player.hand, reason: 'Spent a gray XP token: destroy 1 card.' });
  },
  green: (state, playerId) => grantMagicAttack(state, playerId, 1),
  orange: (state, playerId) => grantGold(state, playerId, 2),
  red: (state, playerId) => grantPhysicalAttack(state, playerId, 1),
  yellow: (state, playerId) => grantLight(state, playerId, 1),
};

export function spendXpToken(state, { playerId, color }) {
  if (!XP_TOKEN_COLORS.includes(color)) throw new Error(`Unknown XP token color: ${color}`);
  const player = getPlayerById(state, playerId);
  if (player.turnFlags.spentXpTokenThisTurn) {
    throw new Error('You have already spent an XP token this turn.');
  }
  if (!player.xpTokens[color]) throw new Error(`You have no ${color} XP tokens to spend.`);

  // Discards this SPECIFIC color's token directly (not via grantXp's own
  // "any color" pick - the player chose exactly which one to spend, unlike
  // every other "discard N XP" card effect where the color is immaterial).
  let nextState = {
    ...state,
    players: state.players.map((p) => (p.id === playerId
      ? { ...p, xp: Math.max(0, p.xp - 1), xpTokens: { ...p.xpTokens, [color]: p.xpTokens[color] - 1 } }
      : p)),
  };
  nextState = { ...nextState, village: { ...nextState.village, xpTokenSupply: { ...nextState.village.xpTokenSupply, [color]: nextState.village.xpTokenSupply[color] + 1 } } };

  nextState = XP_TOKEN_SPEND_EFFECTS[color](nextState, playerId);
  return {
    ...nextState,
    players: nextState.players.map((p) => (p.id === playerId ? { ...p, turnFlags: { ...p.turnFlags, spentXpTokenThisTurn: true } } : p)),
  };
}
